import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { toStartCase } from 'helpers/utils';
import { HighlightText } from 'components';
import { withStyles } from '@material-ui/core/styles';
import {
  compose,
  setDisplayName,
} from 'recompose';

const styles = theme => ({
  tableRowRoot: {
    height: '40px'
  }
});

class OrderSheetTableRow extends Component {
  static contextTypes = {
    isConsumer: PropTypes.bool,
    isPublic: PropTypes.bool,
  };

  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    searchText: PropTypes.string,
    isAllowedZero: PropTypes.bool,
    classes: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    searchText: '',
    isAllowedZero: false,
  };

  getGroups = () => {
    const { data, isAllowedZero } = this.props;
    const modifiedData = [];
    if (!data) return [];
    if (data) {
      let packRowCount = 0;
      data.packrows.forEach((packrow) => {
        if (parseFloat(packrow.availableQuantity, 10) === 0 && !isAllowedZero) return;
        packRowCount++;
        if (packRowCount > 1) {
          modifiedData.push({
            category: toStartCase(data.productData.category),
            ...data,
            ...packrow,
            hide: [
              'action',
              'category',
              'description',
              'image',
              'name',
              'sourcename',
              'status',
              'subname',
              'tags',
              'updatedAt',
            ],
            id: data.id,
            name: data.productData.name,
            subname: data.productData.subname,
          });
          return;
        }
        modifiedData.push({
          category: toStartCase(data.productData.category),
          ...data,
          ...packrow,
          id: data.id,
          name: data.productData.name,
          subname: data.productData.subname,
        });
      });
    }

    return modifiedData;
  };

  render() {
    const { fields, searchText, classes } = this.props;
    const data = this.getGroups();
    const { isConsumer, isPublic } = this.context;
    return (
      <TableRow
        classes={{
          root: classes.tableRowRoot,
        }}
      >
        {
          fields.map((field, index) => (
            <TableCell
              colSpan={field.colSpan || 1}
              key={index}
            >
              {
                data.map((row, index) => {
                  const value = field.render ? field.render({ ...row, setState: this.updateStateData }) : (row.isSeparator ? '' : row[field.name]);
                  const title = field.title ? (
                    typeof field.title === 'function' ? field.title(row) : field.title
                  ) : value;
                  const searchedValue = !field.searchDisabled && !field.render && searchText
                    ? <HighlightText text={value} highlight={searchText} /> : value;
                  const className = field.overflowHidden ? 'overflow-hidden' : typeof field.className === 'function' ? field.className(row) : field.className;
                  const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;
                  const soldOut = Math.floor(parseFloat(row.availableQuantity)) <= 0;

                  return (
                    <div className={`${className || ''} pack-row ${(isConsumer || isPublic) ? 'consumer' : ''}`} key={index} title={title} style={{opacity: soldOut ? 0.5 : 1}}>
                      {!isEmpty && searchedValue}
                    </div>
                  );
                })
              }
            </TableCell>
          ))
        }
      </TableRow>
    );
  }
}

export default compose(
  setDisplayName('OrderSheetTableRow'),
  withStyles(styles),
)(OrderSheetTableRow);

